import { confirmed, password, required, Validator } from '@/entities/validation';
import { PasswordChangingUser } from './model';

export const validate: Validator<PasswordChangingUser> = user => [
  ...required(user.password, 'password'),
  ...password(user.password, 'password'),
  ...required(user.confirm, 'confirm'),
  ...password(user.confirm, 'confirm'),
  ...confirmed(user.confirm, user.password, 'confirm'),
];
